import React, { useState } from "react";
import { Text, View, StyleSheet } from "react-native";
import RangeSlider from "react-native-range-slider-expo";

export default function RangeSliderComponent({
  min,
  max,
  initialFromValue,
  initialToValue,
  onFromValueChange,
  onToValueChange,
}: {
  min: number;
  max: number;
  initialFromValue: number;
  initialToValue: number;
  onFromValueChange: Function;
  onToValueChange: Function;
}) {
  const [fromValue, setFromValue] = useState(initialFromValue);
  const [toValue, setToValue] = useState(initialToValue);

  const handleFromValueChange = (value: any) => {
    setFromValue(value);
    onFromValueChange(value);
  };

  const handleToValueChange = (value: any) => {
    setToValue(value);
    onToValueChange(value);
  };

  return (
    <View
      style={{
        width: "100%",
        position: "relative",
      }}
    >
      <RangeSlider
        style={{ width: "100%", height: 230 }}
        min={min}
        max={max}
        styleSize="medium"
        fromValueOnChange={handleFromValueChange}
        toValueOnChange={handleToValueChange}
        initialFromValue={initialFromValue}
        initialToValue={initialToValue}
        barHeight={2}
        step={1}
        floatingLabel={true}
        inRangeBarColor="#C0A46F"
        outOfRangeBarColor="#CAC9C7"
        fromKnobColor="#C0A46F"
        toKnobColor="#C0A46F"
        showValueLabels={false}
        showRangeLabels={false}
        valueLabelsBackgroundColor="white"
        valueLabelsTextColor="black"
        valueLabelsBorderColor="black"
        knobSize={30}
        containerStyle={{ width: "100%", height: 120 }}
      />
    </View>
  );
}
const styles = StyleSheet.create({
  valueLabelsContainer: {
    width: "100%",
    display: "flex",
    marginTop: 60,
    paddingHorizontal: 20,
    justifyContent: "space-between",

    flexDirection: "row",
  },
  valueLabel: {
    color: "black",
  },
});
